import React, { useEffect, useState } from "react";
import "./SiteReviews.css";
import axios from "axios";
import StarPurple500SharpIcon from "@mui/icons-material/StarPurple500Sharp";
import { useLocation, useNavigate } from "react-router-dom";

const SiteReviews = ({
  limit,
  showButton = false,
  hideHeading = false,
  variant = "grid", // grid | slider
    customHeading, // ✅ Add this new prop

}) => {
  const location = useLocation();
  const navigate = useNavigate();
  const [reviews, setReviews] = useState([]);
  const [showAll, setShowAll] = useState(false);

  const [currentIndex, setCurrentIndex] = useState(0);

  const isReviewPage = location.pathname === "/reviews";
  const isCategoryPage = location.pathname.startsWith("/category/");
  const isLandingPage = location.pathname === "/";
  const categorySlug = isCategoryPage ? location.pathname.split("/")[2] : null;
const isTravelThemePage = location.pathname.startsWith("/travel-theme/");
const travelThemeSlug = isTravelThemePage ? location.pathname.split("/")[2] : null;

  async function getReviews() {    console.log(
    "Fetching reviews for:",
    isCategoryPage
      ? `category: ${categorySlug}`
      : isTravelThemePage
      ? `travel theme: ${travelThemeSlug}`
      : "all"
  );

  try {
    let res;
    if (isCategoryPage && categorySlug) {
      res = await axios.get(`/api/review/get-reviews/${categorySlug}`);
    } else if (isTravelThemePage && travelThemeSlug) {
      res = await axios.get(`/api/review/get-reviews-by-theme/${travelThemeSlug}`);
    } else {
      res = await axios.get("/api/review/get-all-reviews");
    }

    if (res.data.success) {
      // Reverse for consistent order
      setReviews(res.data.data.reverse());
    }
  } catch (error) {
    console.log("Error fetching reviews:", error);
  }

  }

  useEffect(() => {
    getReviews();
  }, [location.pathname]);

// ✅ Detect screen size
const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

useEffect(() => {
  const handleResize = () => setIsMobile(window.innerWidth <= 768);
  window.addEventListener("resize", handleResize);
  return () => window.removeEventListener("resize", handleResize);
}, []);

// ✅ Limit reviews based on device
const displayedReviews = React.useMemo(() => {
  if (!reviews) return [];

  // ✅ Always show all on /reviews page
  if (isReviewPage) return reviews;

  // ✅ Category page → apply "view all" only for grid layout
  if (isCategoryPage && variant === "grid") {
  // ✅ On mobile → show ONLY 1
  if (isMobile) return reviews.slice(0, 1);
  // ✅ On desktop → show 6
  return reviews.slice(0, 6);
}

  // ✅ Category page → slider stays unchanged
  if (isCategoryPage && variant === "slider") {
    return reviews;
  }

  // ✅ Mobile: show only 1 elsewhere
  if (isMobile) return reviews.slice(0, 1);

  // ✅ Normal desktop limit
  if (limit) return reviews.slice(0, limit);

  return reviews;
}, [reviews, isMobile, limit, isReviewPage, isCategoryPage, showAll, variant]);


  useEffect(() => {
    if (variant === "slider" && displayedReviews.length > 1) {
      const interval = setInterval(() => {
        setCurrentIndex((prevIndex) =>
          prevIndex === displayedReviews.length - 1 ? 0 : prevIndex + 1
        );
      }, 5000);
      return () => clearInterval(interval);
    }
  }, [variant, displayedReviews]);
 // ✅ Add this helper to normalize category data
  const parseCategory = (cat) => {
    if (!cat) return [];
    if (Array.isArray(cat)) return cat;
    try {
      const parsed = JSON.parse(cat); // handle stringified arrays like '["xyz"]'
      return Array.isArray(parsed) ? parsed : [parsed];
    } catch {
      return typeof cat === "string" ? cat.split(",").map((c) => c.trim()) : [];
    }
  };
  return (
    <div className={`review-wrapper ${variant === "slider" ? "slider-mode" : ""}`}>
      <div className={`review-container ${variant === "slider" ? "slider-container" : ""}`}>
    {!hideHeading && (
  <h2 className="review-main-heading">
    {customHeading
      ? customHeading
      : isCategoryPage
      ? "What Travellers Say About This Destination"
      : isTravelThemePage
      ? "What Travellers Say About This Travel Theme"
      : "What Travellers Say About Us"}
  </h2>
)}



        {variant === "slider" ? (
          <div className="reviews-grid-final slider-view">
  {displayedReviews.length > 0 && (
    <div className="review-card-final slider-card" key={currentIndex}>
      {/* ⭐ Stars */}
      <div className="review-top-row">
        <div className="stars-final">
          {[...Array(5)].map((_, i) => (
            <StarPurple500SharpIcon key={i} className="star-icon-final" />
          ))}
        </div>
        <img
          src="https://www.gstatic.com/images/branding/product/1x/googleg_32dp.png"
          className="google-logo-final"
          alt="Google logo"
        />
      </div>

      {/* 👤 Image + Name side-by-side */}
      <div className="reviewer-banner-info">
        <img
          src={`https://highmountains.in/reviewImages/${displayedReviews[currentIndex]?.image}`}
          alt={displayedReviews[currentIndex]?.name}
          className="reviewer-img-final"
        />
        <h3 className="reviewer-name-final">
          {displayedReviews[currentIndex]?.name}
        </h3>
      </div>
      {/* 💬 Review text */}
      <p className="review-text-final">
        “{displayedReviews[currentIndex]?.review}”
      </p>

      {/* 👤 Image + Name side-by-side
      <div className="reviewer-banner-info">
        <img
          src={`https://highmountains.in/reviewImages/${displayedReviews[currentIndex]?.image}`}
          alt={displayedReviews[currentIndex]?.name}
          className="reviewer-img-final"
        />
        <h3 className="reviewer-name-final">
          {displayedReviews[currentIndex]?.name}
        </h3>
      </div> */}

      {/* 🔗 Package link below */}
      {displayedReviews[currentIndex]?.packageUrl ? (
        <a
          href={displayedReviews[currentIndex].packageUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="review-package-link"
        >
          Explore the Package
        </a>
      ) : (
        <p className="review-package-link">—</p>
      )}
    </div>
  )}
</div>

        ) : (
          <div className="reviews-grid-final">
  {displayedReviews.map((item, index) => (
    <div className="review-card-final" key={index}>
      
      {/* ⭐ Stars Row */}
      <div className="review-top-row">
        <div className="stars-final">
          {[...Array(5)].map((_, i) => (
            <StarPurple500SharpIcon key={i} className="star-icon-final" />
          ))}
        </div>
        <img
          src="https://www.gstatic.com/images/branding/product/1x/googleg_32dp.png"
          className="google-logo-final"
          alt="Google logo"
        />
      </div>

      {/* 👤 Reviewer Info Row */}
      <div className="reviewer-info-horizontal">
        <img
          src={`https://highmountains.in/reviewImages/${item?.image}`}
          alt={item?.name}
          className="reviewer-img-final"
        />
        <h3 className="reviewer-name-final">{item?.name}</h3>
      </div>

      {/* 🔗 Package Link */}
      {item?.packageUrl ? (
        <a
          href={item.packageUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="review-package-link"
        >
          Explore the Package
        </a>
      ) : (
        <p className="review-package-link">—</p>
      )}

      {/* 💬 Review Text */}
      <p className="review-text-final">“{item?.review}”</p>
    </div>
  ))}
</div>

        )}

        {/* ✅ Category Page (Grid only): inline "View All / Show Less" */}
{/* {isCategoryPage && variant === "grid" && reviews.length > 6 && (
  <button
    className="view-all-btn-final"
    onClick={() => setShowAll((prev) => !prev)}
  >
    {showAll ? "View Less" : "View All Reviews"}
  </button>
)} */}
{isCategoryPage && variant === "grid" && reviews.length > 6 && (
  <button
    className="view-all-btn-final"
    onClick={() => navigate("/reviews")}  // Make sure 'navigate' is imported
  >
    View All Reviews
  </button>
)}

{/* ✅ Default button for other pages (unchanged) */}
{!isCategoryPage && showButton && !hideHeading && limit && reviews.length > limit && (
  <button
    className="view-all-btn-final"
    onClick={() => navigate("/reviews")}
  >
    View All Reviews
  </button>
)}

      </div>
    </div>
  );
};

export default SiteReviews;
